<script setup lang="ts">
import { FormKit } from '@formkit/vue';
import { useSdk } from '~/sdk';
import useNotifications from '~/stores/notifications';

const { send } = useNotifications();
const config = inject(Symbol.for('FormKitConfig')) as any;
const { locale, t } = useI18n();

if (config) {
  config.locale = locale.value;
}

const resetEmail = ref('');
const errors = ref<any>([]);

const onSubmit = async () => {
  errors.value = [];

  const res = await useSdk().commerce.resetPasswordEmail({ email: resetEmail.value });

  if (res.code !== 200 || !res.success) {
    errors.value = [...errors.value, ...[res.message || t('Password reset email not found')]];
    send({
      message: res.message || t('Password reset email not found'),
      type: 'error',
    });
    return;
  }

  send({
    message: t('Password reset email sent successfully'),
    type: 'success',
  });
};
</script>

<template>
  <FormKit type="form" @submit="onSubmit" :submit-label="t('Submit')" class="space-y-4">
    <div class="grid grid-cols-1 gap-3 my-4">
      <FormKit name="email" v-model="resetEmail" :label="t('Email')" type="text" validation="required" />
    </div>
  </FormKit>
</template>
